import { render, staticRenderFns } from "./laborIncome.vue?vue&type=template&id=311caafa&scoped=true&"
import script from "./laborIncome.vue?vue&type=script&lang=js&"
export * from "./laborIncome.vue?vue&type=script&lang=js&"
import style0 from "./laborIncome.vue?vue&type=style&index=0&id=311caafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311caafa",
  null
  
)

export default component.exports